exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ant-table-title {\n  padding: 16px 8px !important;\n}\n.table-title-span {\n  font-weight: 500;\n  font-size: 18px;\n  color: #8e44ad;\n}\n.ant-table-thead {\n  display: none;\n}\n.ant-table-wrapper {\n  margin: 5em;\n  background-color: white;\n}\n.row-option {\n  float: right;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 600;\n  margin: 0.3em 0.4em;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib??postcss!./node_modules/less-loader/dist/cjs.js??ref--5-3!./src/styles/filterTables.less
// module id = 1224
// module chunks = 0